var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{attrs:{"app":"","src":require('@/assets/bg_header_image.png')},scopedSlots:_vm._u([{key:"img",fn:function(ref){
var props = ref.props;
return [_c('v-img',_vm._b({},'v-img',props,false))]}}])},[_c('div',{staticClass:"d-flex align-center"},[_c('v-toolbar-title',{staticClass:"mr-1 display-1 black--text"},[_vm._v("HALO SNPMB")])],1),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }